/* eslint-disable no-console */
import React, {useState} from "react";
import {ErrorMessage, Field, Form, Formik} from "formik";
import Select from "react-select";
/* Components */
import FormErrorMessage from "../../../common/form-elements/form-error-message/form-error-message";
import Input from "../../../common/form-elements/input/input";
import IconButton from "../../../common/icon-button/icon-button";
import ModalDefault from "../../../common/modal/modal-default";
import AdvancedQueryBuilder from "../../../common/advanced-query-builder/advanced-query-builder";
import DeviceInventoryDragAndDrop from "./device-inventory-drag-and-drop/DeviceInventoryDragAndDrop";
import ColumnPill from "../grid/column-pill/column-pill";
import {
    FILTER_TITLE_PLACEHOLDER,
    AUTO_REFRESH_PLACEHOLDER,
    TITLE_INPUT_PLACEHOLDER,
    AUTO_REFRESH_SELECT_LABEL,
} from "./constants";

/* Helpers */
import {
    maxLength,
    minLength,
    required,
    schemaValidate,
} from "../../../../helpers/validation-helpers";
import {
    getColumnsData,
    getFilterProperties,
} from "../../../../pagingfeed/column-helpers/filterProperties";
import {AUTO_REFRESH_OPTIONS} from "../widget-constants";

const DeviceInventoryForm = ({
    saveColumnConfig,
    onFormSubmit,
    initialValues,
    onCancel,
    configData,
    handleFormFieldChange,
    saveSelectedFields,
}) => {
    const [showFilter, setShowFilter] = useState(false);

    const [showColumnReorderAndSelectConfig, setShowColumnReorderAndSelectConfig] = useState(false);

    const toggleFilterModal = () => {
        setShowFilter((showFilter) => !showFilter);
    };

    const handleColumnConfigChange = (columnsConfig) => {
        setShowColumnReorderAndSelectConfig(!showColumnReorderAndSelectConfig);
        saveColumnConfig(columnsConfig);
    };

    const toggleColumnSelectAndReorderModal = () => {
        setShowColumnReorderAndSelectConfig(!showColumnReorderAndSelectConfig);
    };

    const handleFormSelectChange = (props, field) => (value) => {
        props.setFieldValue(field, value);
    };

    const handleSubmit = (values) => onFormSubmit(values);

    return (
        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
            {(props) => {
                return (
                    <Form>
                        <div className="glu-modal__body">
                            <div className="glu-content__section">
                                <div className="glu-form-row">
                                    <div className="glu-label">Widget name</div>
                                    <Field
                                        as={Input}
                                        name="title"
                                        autoFocus
                                        className="glu-form-input-pad"
                                        value={props.values?.title || ""}
                                        onChange={props.handleChange("title")}
                                        validate={schemaValidate([
                                            required(),
                                            minLength(),
                                            maxLength(30),
                                        ])}
                                        invalid={props.errors.title && props.touched.title}
                                        placeholder={TITLE_INPUT_PLACEHOLDER}
                                    />
                                    <ErrorMessage name="title" component={FormErrorMessage} />
                                </div>

                                {configData.selectedPills && (
                                    <div className="glu-form-row">
                                        <div className="glu-label">Selected properties</div>
                                        <div className="glu-flex-row">
                                            {configData.selectedPills.map((item) => (
                                                <ColumnPill
                                                    key={item}
                                                    label={item}
                                                    columnClass="glu-pill--column-selected drag-column"
                                                />
                                            ))}
                                        </div>
                                    </div>
                                )}

                                <div className="glu-form-row">
                                    <div className="glu-flex-row">
                                        <IconButton
                                            icon="sorting"
                                            text="Select and reorder properties"
                                            onClick={toggleColumnSelectAndReorderModal}
                                            className={`glu-flex-shrink ${
                                                configData.selectedPills ? "active" : ""
                                            }`}
                                        />
                                    </div>
                                </div>
                                <div className="glu-form-row">
                                    <div className="glu-label">Auto refresh</div>
                                    <Field
                                        as={Select}
                                        name="autoRefresh"
                                        aria-label={AUTO_REFRESH_SELECT_LABEL}
                                        value={props.values?.autoRefresh}
                                        options={AUTO_REFRESH_OPTIONS}
                                        onChange={handleFormSelectChange(props, "autoRefresh")}
                                        className="glu-select glu-form-input-pad"
                                        classNamePrefix="react-select"
                                        placeholder={AUTO_REFRESH_PLACEHOLDER}
                                    />
                                    <ErrorMessage name="dataType" component={FormErrorMessage} />
                                </div>

                                <div className="glu-form-row">
                                    <div className="glu-label">Filter name</div>
                                    <Field
                                        as={Input}
                                        name="filterName"
                                        className="glu-form-input-pad"
                                        value={props.values?.filterName || ""}
                                        onChange={props.handleChange("filterName")}
                                        placeholder={FILTER_TITLE_PLACEHOLDER}
                                        validate={schemaValidate([maxLength(30)])}
                                        invalid={
                                            props.errors.filterName && props.touched.filterName
                                        }
                                        isDisabled={!props.values.filter.mongoQuery}
                                    />
                                    <ErrorMessage name="filterName" component={FormErrorMessage} />
                                </div>

                                <div className="glu-form-row">
                                    <div className="glu-flex-row">
                                        <IconButton
                                            icon="filter"
                                            text={
                                                Object.keys(configData.filter.mongoQuery || {})
                                                    .length
                                                    ? "Configure filter"
                                                    : "Add filter"
                                            }
                                            className={`glu-flex-shrink ${
                                                Object.keys(configData.filter.mongoQuery || {})
                                                    .length
                                                    ? "active"
                                                    : ""
                                            }`}
                                            onClick={toggleFilterModal}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <footer className="glu-modal__footer">
                            <div className="glu-flex-grow glu-flex-row">
                                <div className="glu-flex-grow text-right">
                                    <button
                                        onClick={onCancel}
                                        className="glu-btn glu-btn--secondary"
                                        type="button"
                                    >
                                        Cancel
                                    </button>
                                </div>
                                <div className="glu-flex-shrink">
                                    <button className="glu-btn glu-btn--primary" type="submit">
                                        Save
                                    </button>
                                </div>
                            </div>
                        </footer>
                        <ModalDefault isOpen={showFilter} customClass="glu-modal__filter">
                            <div className="glu-modal-content">
                                <div className="glu-modal__header">
                                    <div className="glu-modal__title glu-flex-grow">Filter</div>
                                    <div className="glu-flex-shrink">
                                        <button
                                            aria-label="close"
                                            type="button"
                                            className="glu-btn-link g-icon g-icon-close"
                                            onClick={toggleFilterModal}
                                        />
                                    </div>
                                </div>
                                <div className="glu-modal__body">
                                    <div className="glu-content__section">
                                        {showFilter && (
                                            <Field name="filter">
                                                {() => (
                                                    <AdvancedQueryBuilder
                                                        saveFilter={handleFormFieldChange(
                                                            "filter",
                                                            props
                                                        )}
                                                        closeConfigModal={toggleFilterModal}
                                                        type={configData.dataType}
                                                        tree={configData.filter.tree}
                                                        columns={getColumnsData(
                                                            // eslint-disable-next-line max-len
                                                            getFilterProperties(
                                                                configData.dataType.value
                                                            ),
                                                            configData.filterColumnsConfig
                                                        )}
                                                        filterData={configData.filter.mongoQuery}
                                                    />
                                                )}
                                            </Field>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </ModalDefault>
                        <ModalDefault
                            isOpen={showColumnReorderAndSelectConfig}
                            customClass="glu-modal__filter"
                        >
                            <div className="glu-modal-content">
                                <div className="glu-modal__header">
                                    <div className="glu-modal__title glu-flex-grow">
                                        Select and reorder columns
                                    </div>
                                    <div className="glu-flex-shrink">
                                        <button
                                            aria-label="close"
                                            type="button"
                                            className="glu-btn-link g-icon g-icon-close"
                                            onClick={toggleColumnSelectAndReorderModal}
                                        />
                                    </div>
                                </div>
                                <div className="glu-modal__body">
                                    <div className="glu-content__section">
                                        <DeviceInventoryDragAndDrop
                                            saveColumnConfig={handleColumnConfigChange}
                                            columnsConfig={configData.columnsConfig}
                                            saveSelectedFields={saveSelectedFields(
                                                "selectedFields",
                                                props
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                        </ModalDefault>
                    </Form>
                );
            }}
        </Formik>
    );
};

export default DeviceInventoryForm;
